import React from 'react';
import axios from 'axios';
import ErrorMessage from './ErrorMessage'

import '../../styles/common.css';
import '../../styles/messages/CheckInMessage.css';
import { prodConfig } from '../../config'

export default class CheckInMessage extends React.PureComponent {
    state = {
        userList: [],
        nextOffset: 0,
        dialogHead: '',
        dialogContent: '',
        showDialog: false
    };

    constructor() {
        super();
        this.onCheckInClick = this.onCheckInClick.bind(this);
    }

    render() {
        try {
            return (
                <div className="check-in">
                    <a onClick={this.onCheckInClick}>
                        <div className="weui-flex">
                            <div className="weui-flex__item check-in-image flex_1">
                                <img src={`${prodConfig.MAIN_URL}/static/img/check-in-mini.png`} alt="checkin"/>
                            </div>
                            <div className="weui-flex__item check-in-text flex_3">
                                <p className="text-ellipsis check-in-head-text">老师喊你签到啦！</p>
                                <p className="check-in-click-text">点击签到</p>
                            </div>
                        </div>
                        <p className="check-in-inert-notice">签到活动</p>
                    </a>
                </div>
            )
        } catch(e) {
            return <ErrorMessage/>
        }
    }

    onCheckInClick() {
        let {message, lecture} = this.props;
        let url = `/api/classroom/${lecture.id}/checkin/${message.meta.check_in_id}`;
        axios.post(url).then((res) => {
            let rank = res.data.data.rank;
            let checkInCount = res.data.data.checkin.check_in_count;
            let dialogHead = '共' + checkInCount + '人，我是本课堂第' + rank + '位签到';

            this.props.dispatch({
                type: 'SET_CHECK_IN_HEAD',
                preload: dialogHead
            });
        }).then(() => {

            let listUrl = `/api/classroom/${lecture.id}/checkin/${message.meta.check_in_id}/record`;
            axios.get(listUrl).then((res) => {
                let userList = res.data.data.records.map((item) => {
                    let newCheckIn = {
                        icon: <img src={item.account.small_avatar_url} alt="headimg"/>,
                        label: item.account.nickname
                    };
                    return newCheckIn;
                });

                this.props.dispatch({
                    type: 'SHOW_CHECK_IN_DIALOG'
                });
                this.props.dispatch({
                   type: 'SET_CHECK_IN_MESSAGE',
                   preload: message
                });
                this.props.dispatch({
                    type: 'SET_CHECK_IN_OBJECT',
                    preload: {userList: userList, nextOffset: res.data.data.next_offset, hasMore: res.data.data.has_more}
                });
                this.props.dispatch({
                    type: 'SHOW_CHECK_IN_DIALOG'
                });
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/messages/CheckInMessage.js